import { retrieveToken } from '../storage';
import {
  wrapFetch,
  apiFetch,
  apiError,
  OPERAZIONE_NON_CONSENTITA,
  REGISTRAZIONE_DATI_NON_CORRETTI,
  SALVATAGGIO_DATI_NON_CORRETTI,
} from './api';
const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;

export const getLocaliManuale = (manualeId, page, size, sortby) => {
  const token = retrieveToken();
  const PATH = '/api/locali';
  const URL =
    BASE_URL +
    PATH +
    '?manualeId.equals=' +
    manualeId +
    '&page=' +
    page +
    '&size=' +
    size +
    '&sort=' +
    sortby +
    '&' +
    sortby +
    '.dir=ASC';
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const getTotaleLocali = (manualeId) => {
  const token = retrieveToken();
  const PATH = '/api/locali/count?manualeId.equals=' + manualeId;
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const updateLocaliManuale = (requestBody) => {
  const token = retrieveToken();
  const PATH = '/api/locali';
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'PUT',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      400: SALVATAGGIO_DATI_NON_CORRETTI,
    }),
  );
};

export const getAttrezzature = (manualeId, localeId, page, size, sortby) => {
  const token = retrieveToken();
  const PATH = '/api/locali/attrezzature';
  const URL =
    BASE_URL +
    PATH +
    '?manualeId.equals=' +
    manualeId +
    '&localeEsercizioId.equals=' +
    localeId +
    '&page=' +
    page +
    '&size=' +
    size +
    '&sort=' +
    sortby +
    '&' +
    sortby +
    '.dir=ASC';
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};
export const getAttrezzatureWithOnlyManualeId = (
  manualeId,
  page,
  size,
  sortby,
) => {
  const token = retrieveToken();
  const PATH = '/api/locali/attrezzature';
  const URL =
    BASE_URL +
    PATH +
    '?manualeId.equals=' +
    manualeId +
    '&page=' +
    page +
    '&size=' +
    size +
    '&sort=' +
    sortby +
    '&' +
    sortby +
    '.dir=ASC';
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};
export const getAttrezzatureWithManualeIdAndTipologia = (
  manualeId,
  tipologiaId,
  page,
  size,
  sortby,
) => {
  const token = retrieveToken();
  const PATH = '/api/locali/attrezzature';
  const URL =
    BASE_URL +
    PATH +
    '?manualeId.equals=' +
    manualeId +
    '&page=' +
    page +
    '&size=' +
    size +
    '&sort=' +
    sortby +
    '&' +
    sortby +
    '.dir=ASC' +
    '&tipologiaId.equals=' +
    tipologiaId;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const updateAttrezzatureLocale = (requestBody) => {
  const token = retrieveToken();
  const PATH = '/api/locali/attrezzature';
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'PUT',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      400: SALVATAGGIO_DATI_NON_CORRETTI,
      404: 'Salvataggio non riuscito: locale non trovato.',
    }),
  );
};
export const getTipologiaStrumentazione = (manualeId, page, size, sortby) => {
  const token = retrieveToken();
  const PATH = '/api/strumentazioni';
  const URL =
    BASE_URL +
    PATH +
    '?manualeId=' +
    manualeId +
    '&page=' +
    page +
    '&size=' +
    size +
    '&sort=' +
    sortby;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};
export const addNewTipologiaStrumentazione = (body) => {
  const token = retrieveToken();
  const PATH = '/api/strumentazioni';
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'POST',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      body: JSON.stringify(body),
      credentials: 'include',
    }),
    apiError({
      400: REGISTRAZIONE_DATI_NON_CORRETTI,
    }),
  );
};
export const deleteTipologiaStrumentazione = (tipologiaId) => {
  const token = retrieveToken();
  const PATH = '/api/strumentazioni/' + tipologiaId;
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'DELETE',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError({
      400: "Cancellazione non effettuata: la tipologia scelta risulta associata già ad almeno un'attrezzatura del manuale. Modificare le attrezzature assegnandogli una diversa tipologia e ripetere la cancellazione se desiderato.",
      404: OPERAZIONE_NON_CONSENTITA,
    }),
  );
};
